class VideoModal {
    id: string;
    vidSrc: string;
    btnText: string;
    triggerBtns: NodeListOf<HTMLAnchorElement>;

    constructor(){
        this.init();
    }

    init() {
        let self = this;
        self.triggerBtns = document.querySelectorAll('a[data-bs-toggle="modal"]');
        
        if(self.triggerBtns.length > 0){
            self.triggerBtns.forEach(btn => {
                const currentModal = document.querySelector(btn.getAttribute('data-bs-target') + '.video-modal');
           
                if(currentModal != null){
                    btn.addEventListener('click', () => {
                        self.playVidOnOpen(currentModal);
                    })
                    currentModal.addEventListener('hidden.bs.modal', function(){
                        self.stopVidOnClose(currentModal)
                    })
                }
            })
        }
        
        
    }

    playVidOnOpen(target){
        const vidPlaceholder = target.querySelector('.yt-loader');
        if(vidPlaceholder != null){
            const vidSrc = vidPlaceholder.dataset.src;
            let iframe = document.createElement('iframe');
            iframe.src = vidSrc;
            this.replaceWithVideo(vidSrc, vidPlaceholder, iframe);
            iframe.onload = function() {
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'); //plays video
            }
            iframe.focus()
        }
    }

    stopVidOnClose(target){
        const targetVideo: HTMLIFrameElement = target.querySelector('.modal-content iframe');
        if(targetVideo != null){
            targetVideo.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*'); //stops video
        }
    }

    replaceWithVideo(src, target, newVideo) {
        if (!src.includes('?rel=0&modestbranding=1&enablejsapi=1')) {
            newVideo.setAttribute('src', src + '?autoplay=1&rel=0&modestbranding=1&enablejsapi=1');
        } else {
            newVideo.setAttribute('src', src);
        }
        target.replaceWith(newVideo);
    }

}

export default VideoModal;